
import { languages } from "../constants";

function isDict(v: any) {
  return v !== undefined && v !== null && v.constructor == Object;
}

function setDeepKey(obj: any, keys: string[], value: any) {
  if (keys.length == 1) {
    obj[keys[0]] = value;
  }
  else {
    if (!(keys[0] in obj)) {
      obj[keys[0]] = {};
    }
    setDeepKey(obj[keys[0]], keys.slice(1), value);
  }
}

function initTranslations() {
  const translations: any = Object.fromEntries(Object.keys(languages).map((id) => [id, {}]));
  const ctx = require.context(`.`, true, /\.json$/);
  ctx.keys().forEach((filename: string) => {
    const [langId, ...keys] = filename.replace("./", "").replace(".json", "").split("/");
    if (langId in translations) {
      setDeepKey(translations[langId], keys, ctx(filename));
    }
  });
  // traverse the dictionaries and fill in missing keys
  let stack = [{ ...translations, path: [] }];
  while (stack.length) {
    let { en: curBase, path: curPath, ...curOthers } = stack.shift();
    Object.keys(curBase).forEach((key) => {
      let needNextBatch = false;
      let valueOrNextBase = curBase[key];
      let nextOthers: any = {};
      let nextPath = [...curPath, key];
      Object.keys(curOthers).forEach((langId: string) => {
        let curOther = curOthers[langId];
        if (key in curOther) {
          let otherValue = curOther[key];
          if (isDict(valueOrNextBase)) {
            if (isDict(otherValue)) {
              nextOthers[langId] = curOther[key]; 
              needNextBatch = true;
            }
            else {
              curOther[key] = valueOrNextBase;
            }
          }
        }
        else {
          console.warn(`Translation not found for ${nextPath.join('.')} in ${langId}`);
          curOther[key] = valueOrNextBase;
        }
      });
      if (needNextBatch) {
        stack.push({en: valueOrNextBase, ...nextOthers, path: nextPath});
      }
    });
  }
  return translations;
}

export const translations = initTranslations();
